import Image from 'presentation/components/image/index.js';
import { omit, mapValues } from 'mojito/utils';

const BetStatusIcon = props => {
    const { status, mojitoTools } = props;
    const { style } = mojitoTools;
    const imageConfig = style[status];

    if (!imageConfig) {
        return null;
    }

    return <Image config={imageConfig} class="ta-BetStatusIcon" />;
};

BetStatusIcon.getStyle = (config, mode, merge) => {
    const { base, svgPath } = config;
    return mapValues(omit(config, 'base', 'svgPath'), status => {
        const merged = merge(base, status);
        return svgPath && merged.src ? { ...merged, src: `${svgPath}/${merged.src}.svg` } : merged;
    });
};

export default BetStatusIcon;
